exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-bar .brand-title[data-v-3ba85575]{text-decoration:none}", ""]);

// exports
